export default __webpack_public_path__ + "fonts/ca434bb2b63ddb76f77faf1fdc6c2c3b.woff2";